export default {
  dataModel: {
    types: ['pair:Skill'],
    fieldsMapping: {
      title: 'pair:label'
    }
  },
};
